import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class IlIlceAPI extends BaseAPI {


  constructor() {
    const baseUrl = environment.API_URL + "IlIlceListe";
    super(baseUrl);
  }


  getIlIlceListe(ilIlceKodu?: number) {
  
    return this.get("", { params: { ilIlceKodu: ilIlceKodu, } })

  }

}
export default new IlIlceAPI();
class IlIlceRequest {
  public ilIlceKodu?: number;

  constructor(ilIlceKodu?: number) {

    this.ilIlceKodu = ilIlceKodu;

  }
}
export { IlIlceRequest };